// src/components/ProtectedRoute.jsx
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import LoadingSpinner from "./LoadingSpinner";

function ProtectedRoute({ element }) {
  const { user, status } = useSelector((state) => state.user);

  if (status === "loading" || user === undefined) {
    // user not checked yet - show loading instead of null to prevent flicker
    return <LoadingSpinner message="Verifying access..." />;
  }

  // status === "success"
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has no organization - redirect to organization choice
  if (!user.organization) {
    return <Navigate to="/organization-choice" replace />;
  }

  // Check if user needs onboarding
  if (user.organization && user.organization.onboarding && !user.organization.onboarding.isCompleted) {
    const currentStep = user.organization.onboarding.currentStep || 'welcome';
    return <Navigate to={`/onboarding/${currentStep}`} replace />;
  }

  return element;
}

export default ProtectedRoute;
